// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OcdLuihY2H {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.OcdLuihY2H h4 {
  line-height: 3em;
}
.OcdLuihY2H .hEiA1sMvTQ {
  float: left;
  width: 100%;
}
.OcdLuihY2H ._vjwKU8OzM {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.OcdLuihY2H ._vjwKU8OzM:hover {
  cursor: pointer;
}
.OcdLuihY2H ._vjwKU8OzM:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.pPpDb0sCXB .Fcmcn54Irh:focus {
  outline: none;
}
.pPpDb0sCXB .Fcmcn54Irh.Tns0mTT2iU.KP4ku6Ekyn {
  background: #375A88;
}
.pPpDb0sCXB .Fcmcn54Irh.Tns0mTT2iU.KP4ku6Ekyn span {
  color: #fff;
}
.pPpDb0sCXB .KP4ku6Ekyn {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.pPpDb0sCXB .KP4ku6Ekyn:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.pPpDb0sCXB input {
  height: 38px;
  min-width: 220px;
}
._vjwKU8OzM.INREr5R7Wg {
  background: #410102;
}
._vjwKU8OzM.FTX66jOTyl {
  background: #911318;
}
._vjwKU8OzM.l_vzcn6_V9 {
  background: #D8293B;
}
._vjwKU8OzM.k5MAeFWR2h {
  background: #F2373C;
}
._vjwKU8OzM.D1ZvwEUNW7 {
  background: #FC4448;
}
._vjwKU8OzM.TanvjEU3L7 {
  background: #ED535E;
}
._vjwKU8OzM.dSJ1jtC1L2 {
  background: #E34926;
}
._vjwKU8OzM.P0No6yyjnG {
  background: #FC562B;
}
._vjwKU8OzM.ciHc4YIHD6 {
  background: #FC6722;
}
._vjwKU8OzM.snXSls3m1l {
  background: #FD7F24;
}
._vjwKU8OzM.no_D_d0uLU {
  background: #FD8D26;
}
._vjwKU8OzM.UBK8SVQqNs {
  background: #EC9C3E;
}
._vjwKU8OzM.W2ah3189kV {
  background: #0e673a;
}
._vjwKU8OzM.tXGWe__QQz {
  background: #208740;
}
._vjwKU8OzM.sTRNKA1TCy {
  background: #239718;
}
._vjwKU8OzM.ymNbCSknMS {
  background: #55A84D;
}
._vjwKU8OzM.zkkEumGH6z {
  background: #4BBE5A;
}
._vjwKU8OzM.hWn9PzHKlm {
  background: #0CCA6A;
}
._vjwKU8OzM.hNsWLt0cd5 {
  background: #0A3C64;
}
._vjwKU8OzM.uqPNIsQchQ {
  background: #0d487a;
}
._vjwKU8OzM.U12y4OnT5Y {
  background: #10538d;
}
._vjwKU8OzM._fGU7pGzh9 {
  background: #115A99;
}
._vjwKU8OzM.ZzCSZM92aF {
  background: #3387E2;
}
._vjwKU8OzM.FtS5v9BU2U {
  background: #1BA9CF;
}
._vjwKU8OzM.lFRia1edOu {
  background: #d27c02;
}
._vjwKU8OzM.yA55n563i2 {
  background: #fb9402;
}
._vjwKU8OzM.h7G2cCHbbg {
  background: #FD9B30;
}
._vjwKU8OzM.F6uAMsFYrZ {
  background: #FDBE2D;
}
._vjwKU8OzM.rn43vawZas {
  background: #FED831;
}
._vjwKU8OzM.CdkBs_BpuH {
  background: #FFFD38;
}
._vjwKU8OzM.QtDH02ivhO {
  background: #2D215C;
}
._vjwKU8OzM._sPlC1ezHY {
  background: #483C83;
}
._vjwKU8OzM.WSTSizyvUg {
  background: #58518d;
}
._vjwKU8OzM.Danc841if5 {
  background: #7068A9;
}
._vjwKU8OzM.ZzfuV_8_18 {
  background: #7f78b2;
}
._vjwKU8OzM.HMKj53NaFJ {
  background: #8f88bc;
}
._vjwKU8OzM.RqzACN9z26 {
  background: #000;
}
._vjwKU8OzM.W9N4HEkN85 {
  background: #282626;
}
._vjwKU8OzM.epwfj6FOYy {
  background: #242222;
}
._vjwKU8OzM.hSmB0jOV7G {
  background: #353838;
}
._vjwKU8OzM.VGaWyia3Xx {
  background: #666;
}
._vjwKU8OzM.k8lJgGW6yn {
  background: #999;
}
.TKqwlMA0sX {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.TKqwlMA0sX .JBZPIFHuUO {
  display: none;
}
.zVdHIlUzCk {
  padding: 20px;
}
.zVdHIlUzCk .MuiDivider-root {
  margin: 0 -20px;
}
.EZJUmn2r48 {
  margin-bottom: 20px;
}
.QN5x2UapDT {
  display: flex;
  justify-content: space-between;
}
.QN5x2UapDT .T7mNLe2DXh {
  display: flex;
}
.QN5x2UapDT .T7mNLe2DXh ._kf9zAwZXp {
  font-size: 11px;
  margin-right: 8px;
  text-transform: uppercase;
}
.QN5x2UapDT .T7mNLe2DXh .QIkPeKqQmV {
  font-size: 11px;
}
.QN5x2UapDT .B_cSdbLiC8 {
  font-size: 11px;
  color: #DB383B;
}
.QN5x2UapDT .WufR7w6We6 {
  font-size: 11px;
}
.EZJUmn2r48 .w0vohjVbJP.w0vohjVbJP {
  border-color: #DB383B;
}
.CRtzDXaSIX {
  display: flex;
  height: 40px;
  margin-top: 20px;
}
.CRtzDXaSIX .ctdBt03osa {
  align-items: center;
  background-color: #FF9D11;
  border-radius: 4px 0px 0px 4px;
  color: #fff;
  display: flex;
  justify-content: center;
  width: 40px;
}
.CRtzDXaSIX .Y3nnEvgNYO {
  align-items: center;
  background-color: #FFEBCF;
  border-radius: 0px 4px 4px 0px;
  display: flex;
  font-size: 11px;
  height: 100%;
  margin: 0;
  padding-left: 12px;
  padding-right: 20px;
}
.bvzEdJyTqP {
  margin-top: 20px;
}
.OiuYI34VIX {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 12px;
  margin-bottom: 12px;
}
.OiuYI34VIX .O8AptsZbbq .fa-chevron-down {
  display: none !important;
}
.OiuYI34VIX .O8AptsZbbq .tippy-content {
  font-weight: normal;
  text-transform: initial;
}
.OiuYI34VIX .O8AptsZbbq .SCJHMKPuOD {
  font-size: 11px;
}
.OiuYI34VIX .O8AptsZbbq .SCJHMKPuOD i {
  font-size: 11px;
  color: black;
}
.OiuYI34VIX .O8AptsZbbq .z8Jg7tuHdD {
  margin-top: 4px;
}
.OiuYI34VIX .O8AptsZbbq .z8Jg7tuHdD .wrrcvfBpp6 {
  background-color: #fff;
}
.OiuYI34VIX .O8AptsZbbq .z8Jg7tuHdD .wrrcvfBpp6 .gVD0ARTI3u {
  background-color: #f5f6fa;
  max-height: 21px;
  margin: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `OcdLuihY2H`,
	"color-row": `hEiA1sMvTQ`,
	"color-tile": `_vjwKU8OzM`,
	"picker-component": `pPpDb0sCXB`,
	"picker-element": `Fcmcn54Irh`,
	"active": `Tns0mTT2iU`,
	"btn": `KP4ku6Ekyn`,
	"red-1": `INREr5R7Wg`,
	"red-2": `FTX66jOTyl`,
	"red-3": `l_vzcn6_V9`,
	"red-4": `k5MAeFWR2h`,
	"red-5": `D1ZvwEUNW7`,
	"red-6": `TanvjEU3L7`,
	"orange-1": `dSJ1jtC1L2`,
	"orange-2": `P0No6yyjnG`,
	"orange-3": `ciHc4YIHD6`,
	"orange-4": `snXSls3m1l`,
	"orange-5": `no_D_d0uLU`,
	"orange-6": `UBK8SVQqNs`,
	"green-1": `W2ah3189kV`,
	"green-2": `tXGWe__QQz`,
	"green-3": `sTRNKA1TCy`,
	"green-4": `ymNbCSknMS`,
	"green-5": `zkkEumGH6z`,
	"green-6": `hWn9PzHKlm`,
	"blue-1": `hNsWLt0cd5`,
	"blue-2": `uqPNIsQchQ`,
	"blue-3": `U12y4OnT5Y`,
	"blue-4": `_fGU7pGzh9`,
	"blue-5": `ZzCSZM92aF`,
	"blue-6": `FtS5v9BU2U`,
	"yellow-1": `lFRia1edOu`,
	"yellow-2": `yA55n563i2`,
	"yellow-3": `h7G2cCHbbg`,
	"yellow-4": `F6uAMsFYrZ`,
	"yellow-5": `rn43vawZas`,
	"yellow-6": `CdkBs_BpuH`,
	"purple-1": `QtDH02ivhO`,
	"purple-2": `_sPlC1ezHY`,
	"purple-3": `WSTSizyvUg`,
	"purple-4": `Danc841if5`,
	"purple-5": `ZzfuV_8_18`,
	"purple-6": `HMKj53NaFJ`,
	"black-1": `RqzACN9z26`,
	"black-2": `W9N4HEkN85`,
	"black-3": `epwfj6FOYy`,
	"black-4": `hSmB0jOV7G`,
	"black-5": `VGaWyia3Xx`,
	"black-6": `k8lJgGW6yn`,
	"picker-theme": `TKqwlMA0sX`,
	"arrow-regular": `JBZPIFHuUO`,
	"template-settings-modal": `zVdHIlUzCk`,
	"template-settings-modal__name": `EZJUmn2r48`,
	"template-settings-modal__name-root": `QN5x2UapDT`,
	"template-name__container": `T7mNLe2DXh`,
	"template-name__label": `_kf9zAwZXp`,
	"template-name__icon": `QIkPeKqQmV`,
	"template-title__required--invalid": `B_cSdbLiC8`,
	"template-title__required--valid": `WufR7w6We6`,
	"template-title__input--invalid": `w0vohjVbJP`,
	"template-settings-modal__info": `CRtzDXaSIX`,
	"template-info__icon": `ctdBt03osa`,
	"template-info__message": `Y3nnEvgNYO`,
	"template-settings-modal__select": `bvzEdJyTqP`,
	"template-settings-modal__select-row": `OiuYI34VIX`,
	"permission-select__container": `O8AptsZbbq`,
	"permission-title": `SCJHMKPuOD`,
	"permission-select__users-view": `z8Jg7tuHdD`,
	"permission-select__select-container": `wrrcvfBpp6`,
	"user-permission-option": `gVD0ARTI3u`
};
export default ___CSS_LOADER_EXPORT___;
